import { combineReducers } from "redux";
import session from "./session";
import notifications from "./notificatons";
import server from "./server";
import appearance from "./appearance";
import userLocation from "./userLocation";
import cart from './cart';
import search from './search';
import lead from "./lead";
import support from "./support";

export default function createRootReducer(history: any) {
  return combineReducers({
    session,
    notifications,
    server,
    appearance,
    userLocation,
    cart,
    search,
    lead,
    support,
  });
}
